import React, { useReducer } from "react";
import FetcherCacheContext from "./FetcherCacheContext";
import FetcherCacheReducer from "./FetcherCacheReducer";

const FetcherCacheState = ({ children }) => {
  const [cache, dispatch] = useReducer(FetcherCacheReducer, {});

  const setKeyValue = (key, data) => {
    dispatch({ key, data });
  };

  const getKeyValue = (key) => {
    return cache[key];
  };

  return (
    <FetcherCacheContext.Provider
      value={{
        setKeyValue,
        getKeyValue,
      }}
    >
      {children}
    </FetcherCacheContext.Provider>
  );
};

export default FetcherCacheState;
